import { useEffect, useState } from 'react';

const navLinks = [
  { label: '剧情总览', href: '#story' },
  { label: '角色设定', href: '#characters' },
  { label: '剧情解析', href: '#analysis' },
  { label: '结局解析', href: '#ending' },
  { label: '人气排行', href: '#rank' },
  { label: '讨论社区', href: '#community' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80 shadow-none' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-bubble-chart-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-bold text-foreground-900">
            嘿咻嘿咻<span className="text-primary-600">漫画</span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600 whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#community"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-colors hover:bg-background-200"
            aria-label="搜索讨论"
          >
            <i className="ri-search-line text-base" />
          </a>
          <a
            href="#contact"
            className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            加入讨论
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-900 md:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50"
          >
            加入讨论
          </a>
        </div>
      )}
    </header>
  );
}